var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 42,
    viewBox: "0 0 37 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_553_15841)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 37,
    height: 42,
    rx: 8,
    fill: "#EDFAFF"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 50.7081,
    height: 50.4689,
    rx: 5,
    transform: "matrix(0.807496 0.589873 -0.602438 0.798166 8.34668 22.4)",
    fill: "#A6E4FF"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 46.8773,
    height: 46.6562,
    rx: 6,
    transform: "matrix(0.807496 0.589873 -0.602438 0.798166 25.5737 16.1)",
    fill: "#26B0EB"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 9.9615,
    cy: 11.9,
    rx: 3.55769,
    ry: 3.5,
    fill: "#26B0EB"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_553_15841"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 37,
    height: 42,
    rx: 8,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadIcon);
export default __webpack_public_path__ + "static/media/uploadIcon.96b877e4732fcc0f978fb4eb6f838e94.svg";
export { ForwardRef as ReactComponent };